"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createColumn = exports.getValuesFromPreset = void 0;
const utils_1 = require("../utils");
const gridUtils_1 = require("../gridUtils");
function getValuesFromPreset(presets, key) {
    return presets[key] ? presets[key] : [];
}
exports.getValuesFromPreset = getValuesFromPreset;
function createColumn(customCol, presets) {
    return [
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            cellRenderer: 'agGroupCellRenderer',
            filter: 'agTextColumnFilter',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
        },
        {
            field: 'deutsch_kurz',
            headerName: 'Deutsch kurz',
            filter: 'agMultiColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'bks',
            headerName: 'BKS',
            type: 'perm_editConfirmedLabel',
            filter: 'agTextColumnFilter',
            maxWidth: 100,
            valueSetter: (0, gridUtils_1.numericValueSetter)(),
            cellEditor: 'DuplicateTextCellEditor',
            cellEditorParams: {
                parseValue: (value) => value ? Number(value) : null,
            }
        },
        {
            field: 'synonym',
            headerName: 'Synonym',
            filter: 'agTextColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'gattung',
            headerName: 'Gattung',
            filter: 'agMultiColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'xar',
            headerName: 'xAr',
            valueSetter: (0, utils_1.textValidator)(['', 'x']),
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'art',
            headerName: 'Art',
            filter: 'agMultiColumnFilter',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'zusatz',
            headerName: 'Zusatz',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'serie',
            headerName: 'Serie',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'sorte',
            headerName: 'Sorte',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'farbtyp',
            headerName: 'Farbtyp',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'sortenschutz',
            headerName: 'Sortenschutz',
            type: 'perm_editConfirmedLabel',
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: [null, '®', 'PBR'],
            }
        },
        {
            field: 'sortentext',
            headerName: 'Sortentext',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'sortentext_lang',
            headerName: 'Sortentext lang',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'beschreibung',
            headerName: 'Beschreibung',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'blutenfarbe',
            headerName: 'Blütenfarbe',
            cellEditor: 'agRichSelectCellEditor',
            type: 'perm_editConfirmedLabel',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'blutenfarbe'),
            }
        },
        {
            field: 'blute_beetplaner',
            headerName: 'Blüte Beetplaner',
            cellEditor: 'agRichSelectCellEditor',
            type: 'perm_editConfirmedLabel',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'blute_beetplaner'),
            }
        },
        {
            field: 'blutenfarbe_detail',
            headerName: 'Blütenfarbe Detail',
            type: 'perm_editConfirmedLabel'
        },
        {
            field: 'blattfarbe',
            headerName: 'Blattfarbe',
            cellEditor: 'agRichSelectCellEditor',
            type: 'perm_editConfirmedLabel',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'blattfarbe'),
            }
        },
        {
            field: 'blattfarbe_detail',
            headerName: 'Blattfarbe Detail',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'bluhend',
            headerName: 'Blühend',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'blutezeit_von',
            headerName: 'Blütezeit von',
            type: 'perm_editConfirmedLabel',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => {
                value = value < 1 ? 1 : value;
                value = value > 12 ? 12 : value;
                return value;
            }),
            filter: 'agNumberColumnFilter',
        },
        {
            field: 'blutezeit_bis',
            headerName: 'Blütezeit bis',
            type: 'perm_editConfirmedLabel',
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => {
                value = value < 1 ? 1 : value;
                value = value > 12 ? 12 : value;
                return value;
            }),
            filter: 'agNumberColumnFilter',
        },
        {
            field: 'blutezeit',
            headerName: 'Blütezeit',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'blutezeit_sortentext',
            headerName: 'Blütezeit_Sortentext',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'hohe_cm',
            headerName: 'Höhe (cm)',
            valueSetter: (0, gridUtils_1.numericValueSetter)(),
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'lichtbedarf',
            headerName: 'Lichtbedarf',
            cellEditor: 'agRichSelectCellEditor',
            type: 'perm_editConfirmedLabel',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'lichtbedarf'),
            }
        },
        {
            field: 'lichtbedarf_sortentext',
            headerName: 'Lichtbedarf_Sortentext',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'ph_wert',
            headerName: 'pH-Wert',
            filter: 'agMultiColumnFilter',
            cellEditor: 'MultiSelectCellEditorReact',
            type: ['perm_editConfirmedLabel'],
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'ph_wert'),
            }
        },
        {
            field: 'sichtungsergebnis',
            headerName: 'Sichtungsergebnis',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'sichtungsergebnis'),
            }
        },
        {
            field: 'pflanzabstand_cm',
            headerName: 'Pflanzabstand (cm)',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'stk_m2',
            headerName: 'Stk / m2',
            valueSetter: (0, gridUtils_1.numericValueSetter)(),
            type: ['perm_editConfirmedLabel'],
        },
        {
            field: 'lebensbereiche',
            headerName: 'Lebensbereiche',
            filter: 'agMultiColumnFilter',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'MultiSelectCellEditorReact',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'lebensbereiche'),
            },
        },
        {
            field: 'wasserbedarf',
            headerName: 'Wasserbedarf',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'wasserbedarf'),
            }
        },
        {
            field: 'wasserbedarf_sortentext',
            headerName: 'Wasserbedarf_Sortentext',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'wassertiefe_von',
            headerName: 'Wassertiefe von (cm)',
            type: ['perm_editConfirmedLabel'],
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => (0, utils_1.ceilToFive)(value)),
        },
        {
            field: 'wassertiefe_bis',
            headerName: 'Wassertiefe bis (cm)',
            type: ['perm_editConfirmedLabel'],
            valueSetter: (0, gridUtils_1.numericValueSetter)((value) => (0, utils_1.ceilToFive)(value)),
        },
        {
            field: 'wassertiefe',
            headerName: 'Wassertiefe (cm)',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'wassertiefe_sortentext',
            headerName: 'Wassertiefe_Sortentext',
            type: ['derivedColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'wuchsverhalten',
            headerName: 'Wuchsverhalten',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'MultiSelectCellEditorReact',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'wuchsverhalten'),
            }
        },
        {
            field: 'verwendungsart',
            headerName: 'Verwendungsart',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'MultiSelectCellEditorReact',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'verwendungsart'),
            }
        },
        {
            field: 'winterschutz',
            headerName: 'Winterschutz',
            type: 'booleanColumn',
        },
        {
            field: 'bauerngarten',
            headerName: 'Bauerngarten',
            type: 'booleanColumn',
        },
        {
            field: 'bienenweide',
            headerName: 'Bienenweide',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'blattzierend',
            headerName: 'Blattzierend',
            type: 'booleanColumn',
        },
        {
            field: 'uberwiegend_blattzierend',
            headerName: 'überwiegend Blattzierend',
            type: 'booleanColumn',
        },
        {
            field: 'blumenwiese',
            headerName: 'Blumenwiese',
            type: 'booleanColumn',
        },
        {
            field: 'bodendecker',
            headerName: 'Bodendecker',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'dachgarten',
            headerName: 'Dachgarten',
            type: 'booleanColumn',
        },
        {
            field: 'duftstauden',
            headerName: 'Duftstauden',
            type: 'booleanColumn',
        },
        {
            field: 'einfassungspflanzen',
            headerName: 'Einfassungspflanzen',
            type: 'booleanColumn',
        },
        {
            field: 'ungiftig',
            headerName: 'Ungiftig',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'grabbepflanzung',
            headerName: 'Grabbepflanzung',
            type: 'booleanColumn',
        },
        {
            field: 'hangflor_und_loffelsteinbepflanzung',
            headerName: 'Hangflor- und Löffelsteinbepflanzung',
            type: 'booleanColumn',
        }, {
            field: 'heidegarten',
            headerName: 'Heidegarten',
            type: 'booleanColumn',
        },
        {
            field: 'heimische_wildstaude',
            headerName: 'Heimische Wildstaude',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'schotter_und_kiesgarten',
            headerName: 'Schotter- und Kiesgärten',
            type: 'booleanColumn',
        },
        {
            field: 'langzeitwirkung',
            headerName: 'Langzeitwirkung',
            type: 'booleanColumn',
        },
        {
            field: 'dauerbluher',
            headerName: 'Dauerblüher',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'neophyten',
            headerName: 'Neophyten',
            type: 'booleanColumn',
        },
        {
            field: 'remontierend',
            headerName: 'Remontierend',
            type: 'booleanColumn',
        },
        {
            field: 'rhododendronbegleiter',
            headerName: 'Rhododendronbegleiter',
            type: 'booleanColumn',
        },
        {
            field: 'rosenkavaliere',
            headerName: 'Rosenkavaliere',
            type: 'booleanColumn',
        },
        {
            field: 'salzvertraglich',
            headerName: 'salzverträglich',
            type: 'booleanColumn',
        },
        {
            field: 'schneckenresistent',
            headerName: 'Schneckenresistent',
            type: 'booleanColumn',
        },
        {
            field: 'schnittstaude',
            headerName: 'Schnittstaude',
            type: 'booleanColumn',
        },
        {
            field: 'sonnenhang',
            headerName: 'Sonnenhang',
            type: 'booleanColumn',
        },
        {
            field: 'spatzunder',
            headerName: 'Spätzünder',
            type: 'booleanColumn',
        },
        {
            field: 'terrassengarten',
            headerName: 'Terrassengarten',
            type: 'booleanColumn',
        },
        {
            field: 'trittvertraglich',
            headerName: 'Trittverträglich',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'trockener_schatten',
            headerName: 'Trockener Schatten',
            type: 'booleanColumn',
        },
        {
            field: 'trockenheitsvertraglich',
            headerName: 'Trockenheitsverträglich',
            type: 'booleanColumn',
        },
        {
            field: 'trockenmauer',
            headerName: 'Trockenmauer',
            type: 'booleanColumn',
        },
        {
            field: 'wassergarten',
            headerName: 'Wassergarten',
            type: 'booleanColumn',
        },
        {
            field: 'wintergrun',
            headerName: 'Wintergrün',
            type: ['booleanColumn', 'perm_editConfirmedLabel'],
        },
        {
            field: 'fruchtschmuck',
            headerName: 'Fruchtschmuck',
            type: 'booleanColumn',
        },
        {
            field: 'herbstfarbung',
            headerName: 'Herbstfärbung',
            type: 'booleanColumn',
        },
        {
            field: 'heilpflanze',
            headerName: 'Heilpflanze',
            type: 'booleanColumn',
        },
        {
            field: 'wurzpflanze',
            headerName: 'Würzpflanze',
            type: 'booleanColumn',
        },
        {
            field: 'essbar',
            headerName: 'essbar',
            type: 'booleanColumn',
        },
        {
            field: 'prariestauden',
            headerName: 'Präriestauden',
            type: 'booleanColumn',
        },
        {
            field: 'bodendecker_schattig',
            headerName: 'Bodendecker schattig',
            type: 'booleanColumn',
        },
        {
            field: 'stauden_fibel',
            headerName: 'Stauden-Fibel',
            type: 'booleanColumn',
        },
        {
            field: 'perennials_practice',
            headerName: 'Stauden Praxis 2023',
            type: 'booleanColumn',
        },
        {
            field: 'essbare_bluten',
            headerName: 'essbare Blüten',
            type: 'booleanColumn',
        },
        {
            field: 'gartenschatze',
            headerName: 'Gartenschätze',
            type: 'booleanColumn',
        },
        {
            field: 'permakultur',
            headerName: 'Permakultur',
            type: 'booleanColumn',
        },
        {
            field: 'wachstum',
            headerName: 'Wachstum',
            type: 'perm_editConfirmedLabel',
        },
        {
            field: 'vk_argument',
            headerName: 'VK-Argument'
        },
        {
            field: 'zwiebel',
            headerName: 'Zwiebel',
            type: 'booleanColumn',
        },
        {
            field: 'geselligkeit_sks',
            headerName: 'Geselligkeit (SKS)',
            cellEditor: 'MultiSelectCellEditorReact',
            type: ['perm_editConfirmedLabel'],
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'geselligkeit_sks'),
                classes: 'geselligkeit_column_editor_width'
            }
        },
        {
            field: 'winterhartezone_sks',
            headerName: 'Winterhärtezone (SKS)',
            type: ['perm_editConfirmedLabel'],
            cellEditor: 'MultiSelectCellEditorReact',
            cellEditorParams: {
                values: getValuesFromPreset(presets, 'winterhartezone_sks'),
            }
        },
        {
            field: 'qualitat_vorhanden',
            headerName: 'Qualität vorhanden',
            type: ['booleanColumn', 'derivedColumn'],
        },
        {
            field: 'bild',
            headerName: 'Bild',
            type: ['booleanColumn', 'derivedColumn'],
        },
        ...(0, utils_1.customColumnsToColDef)(customCol),
        {
            field: 'created_at',
            headerName: 'Erstellt am',
            type: ['derivedColumn', 'dateColumn'],
        },
        {
            field: 'created_by',
            headerName: 'Created by',
            type: 'hiddenColumn',
        },
        {
            field: 'created_by_name',
            headerName: 'Erstellt von',
            type: 'derivedColumn',
            filter: 'agMultiColumnFilter',
        },
        {
            field: 'updated_at',
            headerName: 'Aktualisiert am',
            type: ['derivedColumn', 'dateColumn'],
        },
        {
            field: 'updated_by',
            headerName: 'Updated by',
            type: 'hiddenColumn',
        },
        {
            field: 'updated_by_name',
            headerName: 'Aktualisiert von',
            filter: 'agMultiColumnFilter',
            type: 'derivedColumn',
        },
        {
            field: 'botanisch_slugged',
            type: 'hiddenColumn',
        },
        {
            field: 'id',
            headerName: 'ID',
            editable: false,
            suppressMenu: true,
            sortable: true,
            maxWidth: 100,
            filter: 'agNumberColumnFilter',
        },
    ];
}
exports.createColumn = createColumn;
